export default {
  OPEN: 'open',
  PARTIAL: 'partial',
  COMPLETE: 'complete',
  PARTIAL_COMPLETE: 'partial complete',
  CANCELLED: 'cancelled'
};
